import React from 'react'
import ContactUsDialog from './dialog/contactUsDialog'

export default function ContactConsultant({
  textPrefix = 'Please',
  textUnderline = 'contact your consultant',
  textPostfix = '',
}) {
  return (
    <span>
      {textPrefix}{' '}
      <ContactUsDialog
        className="link"
        theme="link"
        launchText={textUnderline}
      />{' '}
      {textPostfix}
    </span>
  )
}
